import React, { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { useTheme } from '../../../components/common/Theme';
import { useToast } from '../../../components/common/Toast';
import { OmniChatProvider, useOmniChat } from './omniChatStore';

export type OmniChatOutletContext = {
  isLight: boolean;
  onToast: (type: 'success' | 'error' | 'info', message: string) => void;
};

function OmniChatBody() {
  const { theme } = useTheme();
  const isLight = theme === 'white';
  const { showToast } = useToast();
  const { catalogsReady, catalogsFailedAll } = useOmniChat();
  const onToast = (type: 'success' | 'error' | 'info', message: string) => showToast({ type, message });

  useEffect(() => {
    if (catalogsReady && catalogsFailedAll) {
      onToast('error', 'Could not load gateways.');
    }
  }, [catalogsFailedAll, catalogsReady]);

  return (
    <div className={`w-full min-w-0 -m-3 min-h-[calc(100vh-1.5rem)] ${isLight ? 'bg-slate-50' : 'bg-neutral-950'}`}>
      <div className="px-6 py-6">
        <Outlet context={{ isLight, onToast } satisfies OmniChatOutletContext} />
      </div>
    </div>
  );
}

export function useOmniChatPage(): OmniChatOutletContext {
  return useOutletContext<OmniChatOutletContext>();
}

export default function OmniChatScreen() {
  return (
    <OmniChatProvider>
      <OmniChatBody />
    </OmniChatProvider>
  );
}
